import React, { useState, useRef, useEffect } from 'react';
import TaskTypesList from './TaskTypesList';
import ViewTaskType from './ViewTaskType';
import { useTranslation } from 'react-i18next';
import ResizablePanels from '../../components/Layout/ResizablePanels';
import './Users.css';

const TaskTypes = () => {
  const { t } = useTranslation('admin');
  const [selectedTaskTypeId, setSelectedTaskTypeId] = useState(null);
  const [viewMode, setViewMode] = useState('list');
  const listRef = useRef();
  const viewRef = useRef();

  useEffect(() => {
    updateToolbar(viewMode);
  }, [viewMode, t]);

  const updateToolbar = (mode) => {
    let toolbar = null;

    if (mode === 'list') {
      toolbar = (
        <>
          <button className="toolbar-btn" onClick={handleNew}>
            <span className="icon">+</span> {t('common:ui.new')}
          </button>
          <button className="toolbar-btn" onClick={handleRefresh}>
            <span className="icon">~</span> {t('common:ui.refresh')}
          </button>
        </>
      );
    } else if (mode === 'create' || mode === 'edit') {
      toolbar = (
        <>
          <button className="toolbar-btn primary" onClick={handleSave}>
            <span className="icon">S</span> {t('common:ui.save')}
          </button>
          <button className="toolbar-btn" onClick={handleCancel}>
            <span className="icon">X</span> {t('common:ui.cancel')}
          </button>
        </>
      );
    } else {
      toolbar = (
        <>
          <button className="toolbar-btn" onClick={handleEdit}>
            <span className="icon">E</span> {t('common:ui.edit')}
          </button>
          <button className="toolbar-btn danger" onClick={handleDelete}>
            <span className="icon">D</span> {t('common:ui.delete')}
          </button>
          <button className="toolbar-btn" onClick={handleBack}>
            <span className="icon">&lt;</span> {t('common:ui.back')}
          </button>
        </>
      );
    }

    if (window.setTaskTypesToolbar) {
      window.setTaskTypesToolbar(toolbar);
    }
  };

  const handleSelectTaskType = (taskTypeId) => {
    setSelectedTaskTypeId(taskTypeId);
    setViewMode('view');
  };

  const handleBack = () => {
    setSelectedTaskTypeId(null);
    setViewMode('list');
  };

  const handleNew = () => {
    setSelectedTaskTypeId(null);
    setViewMode('create');
  };

  const handleEdit = () => {
    setViewMode('edit');
  };

  const handleCancel = () => {
    if (viewMode === 'create') {
      setViewMode('list');
      setSelectedTaskTypeId(null);
    } else {
      setViewMode('view');
    }
  };

  const handleSave = () => {
    if (viewRef.current) {
      viewRef.current.handleSave();
    }
  };

  const handleDelete = () => {
    if (viewRef.current) {
      viewRef.current.handleDelete();
    }
  };

  const handleRefresh = () => {
    if (listRef.current) {
      listRef.current.fetchTaskTypes();
    }
  };

  const handleTaskTypeCreated = (taskTypeId) => {
    setSelectedTaskTypeId(taskTypeId);
    setViewMode('view');
    if (listRef.current) {
      listRef.current.fetchTaskTypes();
    }
  };

  const handleSaveComplete = () => {
    setViewMode('view');
    if (listRef.current) {
      listRef.current.fetchTaskTypes();
    }
  };

  return (
    <div className="departments-page">
      <ResizablePanels
        leftPanel={
          <TaskTypesList
            ref={listRef}
            onSelectTaskType={handleSelectTaskType}
            selectedTaskTypeId={selectedTaskTypeId}
            onNew={handleNew}
          />
        }
        rightPanel={
          viewMode !== 'list' ? (
            <ViewTaskType
              ref={viewRef}
              taskTypeId={selectedTaskTypeId}
              editMode={viewMode === 'edit'}
              createMode={viewMode === 'create'}
              onBack={handleBack}
              onEdit={handleEdit}
              onSave={handleSaveComplete}
              onCancel={handleCancel}
              onTaskTypeCreated={handleTaskTypeCreated}
            />
          ) : null
        }
        leftCollapsed={viewMode !== 'list'}
        defaultLeftWidth={40}
        minLeftWidth={30}
        maxLeftWidth={70}
      />
    </div>
  );
};

export default TaskTypes;
